export const container = {
  root: {
    paddingLeft: '1rem !important',
    paddingRight: '1rem !important',
  },
};
